import React from "react";

export const OsIconWearOs = (props: { color?: string }): JSX.Element => {
    const color = props.color ?? "#606060";
    return (
        <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3.24409 1.05993C3.01537 0.558349 2.53962 0.091428 1.97624 0.0216188C1.40142 -0.0494984 0.890354 0.0561147 0.454005 0.448485C0.154495 0.718077 -0.0276302 1.06075 0.00343249 1.47159V1.88031C0.0101355 2.09284 0.0714434 2.28511 0.16267 2.47606L3.92796 10.9387C4.18986 11.5367 4.70469 11.958 5.36894 11.986C5.85613 12.0066 6.16545 11.9382 6.5606 11.6409C7.20507 11.1558 7.34796 10.2667 7.02098 9.55181L3.24409 1.05993Z"
                fill={color}
            />
            <path
                d="M11.6182 9.87956L7.57547 0.818256C7.3631 0.34218 6.87689 0.0799455 6.39574 0H6.03607C5.67673 0.0673569 5.34403 0.217439 5.09536 0.496676C4.86043 0.760381 4.73144 1.07559 4.6994 1.42643C4.67226 1.72349 4.76332 1.99488 4.8843 2.26643L8.8067 11.0709C9.04866 11.6138 9.49514 11.916 10.0577 12H10.3847C10.6819 11.9456 10.9618 11.8416 11.1998 11.6385C11.4939 11.3877 11.6847 11.0322 11.7274 10.644C11.7385 10.5433 11.7485 10.4555 11.7349 10.3576C11.712 10.1935 11.6888 10.0383 11.618 9.87973L11.6182 9.87956Z"
                fill={color}
            />
            <path
                d="M13.981 0.0378858C13.6138 0.0794117 13.2757 0.264807 13.0354 0.537831C12.7632 0.84715 12.6345 1.22432 12.6568 1.63516C12.6994 2.42383 13.3431 3.04246 14.1198 3.07058C14.9114 3.09936 15.6986 2.53614 15.6986 1.74911V1.35674C15.5634 0.518213 14.8611 -0.0618417 13.9812 0.0377223L13.981 0.0378858Z"
                fill={color}
            />
            <path
                d="M13.4548 3.68135C12.8391 3.11846 11.8903 3.12075 11.2799 3.67333C10.9578 3.96483 10.7649 4.34396 10.7345 4.78276C10.7002 5.28009 10.9014 5.77284 11.2725 6.10407C11.8977 6.66205 12.8288 6.66745 13.4571 6.10129C13.8339 5.76173 14.0306 5.26407 13.9908 4.76658C13.9565 4.33775 13.7678 3.96761 13.4548 3.68118V3.68135Z"
                fill={color}
            />
        </svg>
    );
};
